import { render, staticRenderFns } from "./FormsSignedViewer.vue?vue&type=template&id=4b12383a&scoped=true"
import script from "./FormsSignedViewer.vue?vue&type=script&lang=js"
export * from "./FormsSignedViewer.vue?vue&type=script&lang=js"
import style0 from "./FormsSignedViewer.vue?vue&type=style&index=0&id=4b12383a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b12383a",
  null
  
)

export default component.exports